import { render } from "./ContactArea.vue?vue&type=template&id=796212aa&scoped=true"
import script from "./ContactArea.vue?vue&type=script&lang=js"
export * from "./ContactArea.vue?vue&type=script&lang=js"

import "./ContactArea.vue?vue&type=style&index=0&id=796212aa&scoped=true&lang=css"

import exportComponent from "/Users/frknalck/Desktop/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796212aa"]])

export default __exports__